import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getAllByIteration(id: string, filter: any): any {
    return this.http.get(`${this.url}/registrations/outingiteration/${id}`, { params: filter });
  }

  create(form: any){
    return this.http.post(`${this.url}/registration/create`, form);
  }

  createMultiple(dto: any){
    return this.http.post(`${this.url}/registrations/create/multiple`, dto);
  }

  update(id: string, registration: any){
    return this.http.put(`${this.url}/registration/${id}`, registration);
  }

  delete(id: string, dto: any){
    return this.http.post(`${this.url}/registration/delete/${id}`, dto);
  }

  processCardPayment(data: any): any{
    return this.http.post(`${this.url}/registration/processpayment/reader`, data);
  }

  refundPayment(data: any): any{
    return this.http.post(`${this.url}/registration/refund/card`, data);
  }

  createCashInvoice(data: any): any{
    return this.http.post(`${this.url}/registration/invoice/cash/create`, data);
  }

  updateCashInvoice(data: any): any{
    return this.http.post(`${this.url}/registration/invoice/cash/update`, data);
  }

  createPaymentIntent(data: any): any{
    return this.http.post(`${this.url}/registration/paymentintent/create`, data);
  }

  cancelPaymentIntent(dto: any): any{
    return this.http.post(`${this.url}/registration/paymentintent/cancel`, dto);
  }
}
